import React from 'react';
import DModal from '@/components/Global/DModal';
import DButton from '@/components/Global/DButton';
import CloseIcon from '@/shared/icons/CloseIcon';
import claudeModalImg from '@/assets/modal/Claude-modalImg.png';

const DModalClaudeModels = ({ isOpen, onClose, onTryNow, position = 'center' }) => {
  const handleTryNow = () => {
    if (onTryNow) {
      onTryNow();
    }
    onClose();
  };

  return (
    <DModal
      isOpen={isOpen}
      onClose={onClose}
      hideCloseButton={true}
      className="!w-[260px] max-w-none overflow-visible !rounded-2xl claude-modal-slide"
      headerClassName="hidden"
      contentBgColor="bg-white rounded-2xl"
      line={false}
      contentGap=""
      contentPadding=""
      position={position}
    >
      <button
        onClick={onClose}
        className="absolute top-[-8px] right-[-8px] z-50 p-1 bg-gray-100 hover:bg-gray-100 rounded-full transition-colors"
      >
        <CloseIcon width={20} height={20} />
      </button>

      <div className="relative w-full overflow-hidden rounded-t-2xl font-sora">
        <div className="relative w-full h-full flex items-center justify-center">
           <img
            src={claudeModalImg}
            alt="Claude Models Banner"
            className="w-full h-auto"
          />
        </div>

        {/* Content Section */}
        <div className="p-3 flex flex-col gap-2">
          <h1 className='text-left text-sm font-semibold'>New Claude Models</h1>
            <p className="text-left text-gray-700 text-[11px] leading-tight">
              Your agents just got smarter, faster, and more capable, powered by our expanding suite of the latest LLMs.
          </p>
          <div className="flex justify-end pt-0">
            <DButton
              onClick={handleTryNow}
              className="bg-[#303CB4] hover:bg-blue-700 text-white px-4 py-1 rounded-full text-xs  transition-colors"
            >
              Try it now
            </DButton>
          </div>
        </div>
      </div>
    </DModal>
  );
};

export default DModalClaudeModels;

